export default function Header() {
    // Header container styles (bg-white, shadow, py-4)
    const headerStyle = {
      backgroundColor: "#fff",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      paddingTop: "16px", // roughly py-4
      paddingBottom: "16px"
    };
  
    // Container centered horizontally (mx-auto) with flex layout
    // Changed justifyContent from "space-between" to "center" to center the content.
    const containerStyle = {
      maxWidth: "1200px", // adjust as needed for your design
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center", // Center the header content horizontally
      paddingLeft: "16px",
      paddingRight: "16px"
    };
  
    // Title styles (text-3xl, ml-5, font-semibold, text-gray-700)
    const titleStyle = {
      fontSize: "2rem", // approximate for text-3xl
      marginLeft: "20px",
      fontWeight: "600",
      color: "#4a5568" // similar to gray-700
    };
  
    return (
      <header style={headerStyle}>
        <div style={containerStyle}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h1 style={titleStyle}>Wikimedia YoY Growth</h1>
          </div>
        </div>
      </header>
    );
  }
  